import capitalize from 'lodash/capitalize';
import startCase from 'lodash/startCase';

import { IntegrationType } from '../useIntegrations/integrations';

type GetTooltipContentProps = {
  cardType?: string;
  integrationType?: IntegrationType;
};

const customCardTypes = ['custom', 'magento', 'salesforce'];

/** A function that returns the tooltip content for an integration. */
export const getTooltipContent = ({
  cardType,
  integrationType,
}: GetTooltipContentProps): string | null => {
  if (!integrationType || !cardType) {
    return null;
  }

  if (customCardTypes.includes(cardType)) {
    return cardType === 'custom'
      ? capitalize(startCase(integrationType))
      : `${startCase(cardType)} custom card`;
  }

  return `${startCase(cardType)} native integration`;
};
